export default __webpack_public_path__ + "static/media/logo-black.24b732aa.svg";